export default __webpack_public_path__ + "static/media/cake.781d6436.svg";